// remove ?partial=1 from URL if it exists
if (window.location.search.includes('partial=1')) {
  const url = new URL(window.location.href);
  url.searchParams.delete('partial');
  window.history.replaceState({}, '', url.pathname + url.search);
}

(function ($) {

	var $window = $(window),
		$body = $('body'),
		$menu = $('#nav-bar'),
		$sidebar = $('#sidebar'),
		$main = $('#main');

	// Breakpoints.

	// breakpoints({
	// 	xlarge: ['1281px', '1680px'],
	// 	large: ['981px', '1280px'],
	// 	medium: ['737px', '980px'],
	// 	small: ['481px', '736px'],
	// 	xsmall: [null, '480px']
	// });

	// Play initial animations on page load.
	$window.on('load', function () {
		window.setTimeout(function () {
			$body.removeClass('is-preload');
		}, 100);
	});

	// Menu.
	if ($menu.length && $.fn.panel) {
		$menu.appendTo($body).panel({
			delay: 500,
			hideOnClick: true,
			hideOnSwipe: true,
			resetScroll: true,
			resetForms: true,
			side: 'right',
			target: $body,
			visibleClass: 'is-menu-visible'
		});
	} else {
		console.warn('#menu missing or panel plugin not loaded');
	}

	// Search (header).
	var $search = $('#search'),
		$search_input = $search.find('input');

	$body
		.on('click', '[href="#search"]', function (event) {

			event.preventDefault();

			// Not visible?
			if (!$search.hasClass('visible')) {

				// Reset form.
				$search[0].reset();

				// Show.
				$search.addClass('visible');

				// Focus input.
				$search_input.focus();

			}

		});

	$search_input
		.on('keydown', function (event) {

			if (event.keyCode == 27)
				$search_input.blur();

		})
		.on('blur', function () {
			window.setTimeout(function () {
				$search.removeClass('visible');
			}, 100);
		});

	// Intro.
	var $intro = $('#intro');

	// Move to main on <=large, back to sidebar on >large.
	// breakpoints.on('<=large', function () {
	// 	$intro.prependTo($main);
	// });

	// breakpoints.on('>large', function () {
	// 	$intro.prependTo($sidebar);
	// });

})(jQuery);
//showModal('You are about to navigate to a different website.', () => console.log('Confirmed!'));
//<?php get_template_part('template-parts/layout/site', 'modalVariantA'); ?>